

/**
 *@fileoverview 对话框
 *@author zhenn
 */

define(function (require, exports, module) {

    var Layer = require('c-layer');
    var Mask = require('c-mask');

    var templateList = ['<div class="widget-dialog">', '<div class="widget-dialog-content">{{content}}</div>', '<div class="widget-dialog-footer">', '<button type="button" class="close" data-id="close">取消</button>', '<button type="button" class="confirm" data-id="confirm">确定</button>', '</div>', '</div>', '<style type="text/css">', '.widget-dialog { z-index:100; position: absolute; background: #fff; border: 0.03125rem solid #eee; height: 4rem; top: 50%; font-size: 0.5rem; left: 50%; width: 7rem; margin: -2rem 0 0 -3.5rem; border-radius: 0.21875rem;}', '.widget-dialog-content { text-align: center; width: 7rem; height: 2.5rem; display:table-cell; vertical-align:middle; }', '.widget-dialog-footer { height: 1rem;text-align:center;}', '.widget-dialog-footer button {  width: 2.8125rem; border: 0.03125rem solid #eee; border-radius: 0.15625rem; height: 1rem; color: #fff; font-size:0.5rem; background: #aaa; }', '.widget-dialog-footer button.confirm { background: #ff9018;}', '.widget-dialog-footer button.close {margin-right: 0.375rem;}', '</style>'];

    var Dialog = Layer.extend({

        defaults: {
            content: '确认要进行此操作吗？',
            template: templateList.join(''),
            type: 'alert' // 'confirm'
        },

        constructor: function constructor() {
            this.Parent.apply(this, arguments);
            this.mask = new Mask({
                hideWhenTap: 0
            });
        },

        create: function create() {
            var self = this;
            var template = self.get('template');
            var content = self.get('content');
            this.mask.create();
            self.set('template', template.replace('{{content}}', content));
            // $(document.body).append(cssList.join(''));
            self.Parent.apply(self, arguments);

            if (self.get('type') == 'alert') {
                self.get('el').find('[data-id=close]').remove();
            }
            self.bindEvent();
        },

        bindEvent: function bindEvent() {
            var self = this;
            var el = this.get('el');

            el.on('click', '[data-id=close]', function () {
                self.mask.destroy();
                self.destroy();
                self.emit('close');
            });
            el.on('click', '[data-id=confirm]', function (e) {
                self.mask.destroy();
                self.destroy();
                self.emit('confirm', e);
            });
        }

    });

    module.exports = Dialog;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/c-dialog/dist/index.js
// module id = 690
// module chunks = 0